export default __webpack_public_path__ + "static/media/general-skills.9cb63950.jpg";